import {
  Button as MUIButton,
  ButtonProps,
  Stack,
  useMediaQuery,
} from '@mui/material'
import { useTheme, styled } from '@mui/material/styles'
import { Link } from 'gatsby'
import React from 'react'
import { ArrowRightBold } from 'components/atoms/icon/arrow_right_bold'
import { Body } from 'components/atoms/typography/body'
import { Caption } from 'components/atoms/typography/caption'

type Props = Omit<ButtonProps, 'color'> & {
  color: 'marine' | 'coral'
  icon: string
  label: string
  to?: string
}

const StyledIllustrationIcon = styled('img')(({ theme }) => ({
  width: 48,
  height: 48,
  [theme.breakpoints.up('lg')]: {
    width: 54,
    height: 54,
  },
}))

const StyledArrowIcon = styled(ArrowRightBold)(({ theme }) => ({
  width: 11,
  height: 18,
  [theme.breakpoints.up('lg')]: {
    width: 12,
    height: 20,
  },
}))

export const ButtonFooter: React.FC<Props> = ({
  color,
  icon,
  label,
  to,
  sx,
  ...buttonProps
}) => {
  const MuiTheme = useTheme()
  const isLg = useMediaQuery(MuiTheme.breakpoints.up('lg'))
  const colorMap = {
    marine: {
      color: MuiTheme.palette.primary.main,
      backgroundColor: MuiTheme.palette.background.marine,
    },
    coral: {
      color: MuiTheme.palette.text.brown,
      backgroundColor: MuiTheme.palette.background.coral,
    },
  }

  return (
    <MUIButton
      to={to}
      component={!!to && Link}
      sx={{
        height: 'auto',
        width: '100%',
        maxWidth: 390,
        boxShadow: 0, // デフォルトスタイルのドロップシャドウ打ち消し
        color: colorMap[color].color,
        background: colorMap[color].backgroundColor,
        borderRadius: 1,
        py: 1,
        pl: { xs: 2, lg: 3 },
        pr: 2,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textTransform: 'none',
        '&:hover': {
          color: colorMap[color].color, // デフォルトスタイルのcolor打ち消し
          background: colorMap[color].backgroundColor, // デフォルトスタイルのbackground打ち消し
          opacity: '0.6',
        },
        ...sx,
      }}
      {...buttonProps}
    >
      <Stack direction="row" alignItems="center" spacing={{ xs: 1, lg: 2 }}>
        <StyledIllustrationIcon src={icon} alt="ボタンアイコン" />
        {isLg ? (
          <Body color="inherit" bold>
            {label}
          </Body>
        ) : (
          <Caption color="inherit" bold>
            {label}
          </Caption>
        )}
      </Stack>
      <StyledArrowIcon fill={colorMap[color].color} />
    </MUIButton>
  )
}
